<template>
<div class="floatBar" >
  <!-- <transition name="van-slide-left"> -->
  <div class="floatBarhide" v-if="showRightBar" @click="showRightBar = false">
    <img src="@/assets/images/leftArrow.png" />
    <span>快速导航</span>
  </div>
  <!-- </transition> -->
    
  <van-overlay :show="!showRightBar"  >
    <transition name="van-slide-right">
      <div class="floatBarshow" v-if="!showRightBar" @click="showRightBar = true">
        <div class="floatBarshowL">
          <img src="@/assets/images/rightArrow.png" />
          <span>收起</span>
        </div>
        <div class="floatBarshowR">
          <div class="floatBarshowRcol" @click="goNext('member')">
            <img src="@/assets/images/home1.png" />
            <span>首页</span>
          </div>
          <div class="floatBarshowRcol" @click="goNext('category')">
            <img src="@/assets/images/category1.png" />
            <span>分类</span>
          </div>
          <div class="floatBarshowRcol" @click="goNext('memberCode')">
            <img src="@/assets/images/membercode1.png" />
            <span>会员码</span>
          </div>
          <div class="floatBarshowRcol" @click="goNext('shoppingCar')">
            <img src="@/assets/images/shopcar1.png" />
            <span>购物车</span>
          </div>
          <div class="floatBarshowRcol" @click="goNext('my')">
            <img src="@/assets/images/foot_person.png" />
            <span>我的</span>
          </div>
        </div>
      </div>
    </transition>
  </van-overlay>
    
</div>
</template>
<script>
export default {
  name: '',
  components:{

  },
  data () {
    return {
      showRightBar:true,
    }
  },
  methods: {
    goNext(name){
      this.$reLaunch(name,{urlstr:name})
      
      this.$service.getStatisCommon("evn_close_page",{});
    },
  }
}
</script>
<style scoped lang='less'>
.floatBarhide{
  width:1.5467rem;
  height:1.2267rem;
  background:rgba(0,0,0,0.7);
  border-radius:2.2667rem 0rem 0rem 2.2667rem;
  position: fixed;
  right: 0;
  bottom: 2.9867rem;
  display: flex;
  align-items: center;
}

.floatBarhide img{
  width: 0.4267rem;
  height: 0.4267rem;
  margin-left: 0.1067rem;
  margin-right: 0.0533rem;
}
.floatBarhide span{
  font-size:0.3467rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:0.48rem;
}
.floatBarshow{
  position: fixed;
  right: 0;
  bottom: 2.9867rem;
  display: flex;
  align-items: center;
}
.floatBarshowL{
  width:1.4933rem;
  height:0.96rem;
  background:rgba(0,0,0,0.7);
  border-radius:2.2667rem 0rem 0rem 2.2667rem;
  display: flex;
  align-items: center;
}
.floatBarshowL img{
  width: 0.4267rem;
  height: 0.4267rem;
  margin-left: 0.1067rem;
  margin-right: 0.0533rem;
}
.floatBarshowL span{
  width:0.6933rem;
  font-size:0.3467rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:0.48rem;
}
.floatBarshowR{
  width:4.2933rem;
  height:3.7333rem;
  background:rgba(255,255,255,1);
  border-radius:0.2133rem 0rem 0rem 0.2133rem;
  padding: 0.2133rem 0;
}
.floatBarshowRcol{
  width: 33%;
  float: left;
  text-align: center;
  margin: 0.2133rem 0;
}
.floatBarshowRcol img{
  width: 0.72rem;
  height: 0.72rem;
}
.floatBarshowRcol span{
  font-size:0.32rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(0,0,0,0.46);
  line-height:0.4533rem;
  display: block;
}
</style>